export default __webpack_public_path__ + "static/media/cards3.89742188.png";